import { CSSProperties } from "react"
import { ANIMATED_STYLE } from "src/libs/interfaces/animated"
import { DIALOG_SIZE } from "src/libs/interfaces/layouts"
import { __, getID } from "src/libs/utilities"
import { DEFAULT_SECTION_PADDING, ILanding, ILandingDelimiter, ILandingSection, ILandingSectionBackground, ILandingSectionDescription, ILandingSectionTitle, SECTION_PROPORTION_TYPE } from "../interfaces"
import { useLandingStore } from "../store"

export const defaultSection = () : ILandingSection => {
    const currentLanding: ILanding = useLandingStore.getState && useLandingStore.getState() ? useLandingStore.getState().currentLanding : {} as ILanding
    return {
        id: getID("section"), 
        composition: {
            columns: 1,
            container: currentLanding.dataSize || DIALOG_SIZE.NORMAL,
            proportia: [100],
            type: SECTION_PROPORTION_TYPE.NONE
        },
        animated: [ANIMATED_STYLE.FADE_IN], 
        animated_delay: 0,
        data: [ ], 
        title: {
            text: __("New section")
        } as ILandingSectionTitle, 
        description: {} as ILandingSectionDescription, 
        delimiter: { 
            isDisabled: true
        } as ILandingDelimiter, 
        maxSectionID: 0,
        maxFloatID: 0, 
        length: 1, 
        floats : [], 
        position: {},
        className: "",
        paddingTop: currentLanding.defaultPadding || DEFAULT_SECTION_PADDING,
        paddingBottom: currentLanding.defaultPadding || DEFAULT_SECTION_PADDING,
        style: {} as CSSProperties,
        dstyle: {} as CSSProperties,
        dimentions: {},
        background : {} as ILandingSectionBackground
    }
}